module.exports = __webpack_public_path__ + "img/new_34.38f64617.jpg";